import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwGallery extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {

        }

    }

    __PageReady(){
        this.$el.find('.auw-gallery__link').fancybox({
             loop:this.config.loop,
             buttons: [
                 "zoom",
                 "close"
             ],
             caption : function( instance, item ) {
                 var figureTag = item.$thumb.parents('figure');
                 if(figureTag.find("figcaption").length){
                     return figureTag.find("figcaption").html();
                 }

             }
        });
    }
}